import { useMemo, useState, PropsWithChildren } from 'react';
import createSafeContext from '@paradigm/utils/createSafeContext';

interface RfqFiltersModalMethods {
  readonly open: () => void;
  readonly close: () => void;
}

interface RfqFiltersModalState {
  readonly isOpen: boolean;
}

export const [useRfqFiltersModalState, ModalStateProvider] =
  createSafeContext<RfqFiltersModalState>('RfqFiltersModalState');

export const [useRfqFiltersModalMethods, ModalMethodsProvider] =
  createSafeContext<RfqFiltersModalMethods>('RfqFiltersModalMethods');

export const RfqFiltersModalProvider = ({ children }: PropsWithChildren) => {
  const [isOpen, setIsOpen] = useState(false);

  const state: RfqFiltersModalState = {
    isOpen,
  };

  const methods = useMemo(
    (): RfqFiltersModalMethods => ({
      open: () => setIsOpen(true),
      close: () => setIsOpen(false),
    }),
    [],
  );

  return (
    <ModalStateProvider value={state}>
      <ModalMethodsProvider value={methods}>{children}</ModalMethodsProvider>
    </ModalStateProvider>
  );
};
